import NAME from "./constants";

export const getFavouriteList = store => store[NAME].favouriteList;
export const getIsLoading = store => store[NAME].isLoading;